import { BinaryTuple } from "abweb/dto/ds/BinaryTuple";
import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { DataSourceValueBinaryBase } from "abweb/dto/generated/ds/DataSourceValueBinaryBase";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
import { NumberUtils } from "abweb/utils/NumberUtils";
import { StringUtils } from "abweb/utils/StringUtils";
export class DataSourceValueBinary extends DataSourceValueBinaryBase {
  constructor() {
    super();
  }
  initDataSourceValueBinary(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baselineRef, currentValue, valueRef) {
    super.initDataSourceValueBinary(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baselineRef, currentValue, valueRef);
    if (currentValue == null) {
      this.currentValue = new BinaryTuple();
      this.currentValue.value = valueRef.value;
      this.currentValue.displayValue = valueRef.displayValue;
    }
  }
  get isAttachedFile() {
    const tuple = this.get("currentValue");
    return tuple && !StringUtils.isNullOrEmpty(tuple.displayValue);
  }
  get isRemoteFile() {
    return !this.isAttachedFile;
  }
  get isBinary() {
    return true;
  }
  getCurrentValue() {
    return this.currentValue;
  }
  getValue() {
    return this.valueRef;
  }
  getBaseline() {
    return this.baselineRef;
  }
  getDisplayValue() {
    const tuple = this.get("currentValue");
    return this.getFormattedValue(tuple);
  }
  getCanonicalEditValue() {
    const tuple = this.get("currentValue");
    if (tuple == null) {
      return null;
    }
    return tuple.value;
  }
  getFormattedValue(value) {
    if (value == null) {
      return "";
    }
    const ref = value;
    if (!ref.displayValue) {
      return StringUtils.emptyIfNull(ref.value);
    }
    if (ref.displayValue.charAt(0) === "@") {
      return ref.displayValue.substring(1);
    }
    return ref.displayValue;
  }
  areEqual(value1, value2) {
    if (value1 == null && value2 == null) {
      return true;
    }
    if (value1 == null || value2 == null) {
      return false;
    }
    const tuple1 = value1;
    const tuple2 = value2;
    return normalizeBinaryTupleValue(tuple1.value) === normalizeBinaryTupleValue(tuple2.value) && tuple1.displayValue === tuple2.displayValue;
  }

  // If the value gets set directly, the displayValue should go away. The value is the path to the file. The
  // displayValue is only used for attached files that have been uploaded to the server.
  coerceAndSetCurrentValue(value) {
    const retVal = super.coerceAndSetCurrentValue(value);
    if (retVal) {
      this.set("displayValue", null);
    }
    return retVal;
  }
  coerceValue(value) {
    // Note that for a binary type, we will coerce this to a BinaryTuple
    const tuple = BinaryTuple.createBinaryTuple(null, null);
    if (value == null) {
      return tuple;
    }
    if (ClassUtils.isInstanceOf(value, BinaryTuple)) {
      tuple.displayValue = value.displayValue;
      tuple.value = value.value;
      return tuple;
    }
    if (ClassUtils.isInstanceOf(value, DataSourceValue)) {
      // Assume we want to set the value only
      value = value.getCurrentValue();
    }

    // Use our current value of displayValue, we're only going to change value
    tuple.displayValue = this.getDisplayValue();
    if (value == null) {
      return tuple;
    }

    // Convert the value to a string and use it as the value.
    const t = typeof value;
    if (t === "string") {
      tuple.value = value;
    } else if (t === "number") {
      tuple.value = NumberUtils.formatValue(value);
    } else if (ClassUtils.isInstanceOf(value, Date)) {
      tuple.value = DateTimeUtils.DATE_SHORT.format(value);
    } else {
      tuple.value = value.toString();
    }
    return tuple;
  }
  isEmpty() {
    if (super.isEmpty()) {
      return true;
    }
    return StringUtils.isNullOrEmpty(this.getCanonicalEditValue());
  }
}

/**
 * Utility. Editing UI can set tuple.value to empty string, but comes back from server as null.
 * This normalizes empty string to null.
 */
function normalizeBinaryTupleValue(value) {
  return value || null; // return truthy values, or null. Empty string is falsy, will return null.
}
//# sourceMappingURL=DataSourceValueBinary.js.map
